:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  /**
   * @prop --ch-tooltip-separation:
   * Specifies the separation between the action and the displayed tooltip.
   * @default 0px
   */
  --ch-tooltip-separation: 0px;
  /**
    * @prop --ch-tooltip-separation-x:
    * Specifies the separation between the action and the tooltip displayed
    * on the x-axis.
    * @default var(--ch-tooltip-separation)
    */
  --ch-tooltip-separation-x: var(--ch-tooltip-separation);
  /**
    * @prop --ch-tooltip-separation-y:
    * Specifies the separation between the action and the tooltip displayed
    * on the y-axis.
    * @default var(--ch-tooltip-separation)
    */
  --ch-tooltip-separation-y: var(--ch-tooltip-separation);
  display: contents;
}

ch-popover {
  --ch-popover-separation-x: var(--ch-tooltip-separation-x);
  --ch-popover-separation-y: var(--ch-tooltip-separation-y);
  animation: delay-visibility var(--ch-tooltip-delay) linear;
}
ch-popover:not(.hydrated) {
  display: none;
  opacity: 0;
}

@keyframes delay-visibility {
  0%, 100% {
    opacity: 0;
  }
}